import { z } from 'zod';

import { getGeneralStaticBuilderSchema } from '~/utils/validation/qrCodeBuilder';

export const getSchema = ({ t }) => {
  return z
    .object({
      email: z
        .string()
        .max(254, { message: t('errors:max', { count: 254 }) })
        .email(t('errors:emailIsValid')),
      subject: z
        .string()
        .max(100, { message: t('errors:max', { count: 100 }) })
        .optional(),
      message: z
        .string()
        .max(200, { message: t('errors:max', { count: 200 }) })
        .optional(),
    })
    .merge(getGeneralStaticBuilderSchema());
};
